export default {"src":"/_next/static/media/ra-group-user.497b2d5f.svg","height":52,"width":52,"blurWidth":0,"blurHeight":0};